import { combineReducers } from 'redux';
import authReducer from './AuthReducer';
import logInReducer from './LogInRedcuder';
import dashboardReducer from './DashboardReducer';
import proReducer from './ProReducer';
import supportReducer from './SupportReducer';
import pushReducer from './PushReducer';
import coachReducer from './CoachReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  logIn: logInReducer,
  dashboard: dashboardReducer,
  pro: proReducer,
  support: supportReducer,
  push: pushReducer,
  coach: coachReducer
});


export default (state,action) => {
	if (action.type === 'LOGOUT') {
		state = {};
	}

	return rootReducer(state,action);
};



// WEBPACK FOOTER //
// ./src/reducers/index.js